/* eslint-disable react-hooks/rules-of-hooks */
import { useRecoilState, useSetRecoilState } from 'recoil'
import styled from '@emotion/styled'
import { Close } from '@emotion-icons/material/Close'
import { Cube } from '@emotion-icons/boxicons-regular/Cube'
import { Typography } from '@mui/material'
import { Colors, Levels, Shapes, Typographies, useTypography } from 'src/components/theme'
import { ButtonWithIcon } from 'src/components/button/button-with-icon'
import { Satellite } from '@emotion-icons/fa-solid/Satellite'

import * as mainMapAtoms from 'src/atoms/main-map'
import { NO_PRINT_REPORTS } from 'src/utils/html-to-image'

const AerialBannerWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  height: 36px;
  width: 100%;
  padding: ${Shapes.spacing[2]}px;
  gap: ${Shapes.spacing[4]}px;
  align-items: center;
  justify-content: center;
  background-image: linear-gradient(0deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1)),
    linear-gradient(180deg, rgba(255, 255, 255, 0.084) 0%, rgba(66, 66, 66, 0.084) 51.5%, rgba(0, 0, 0, 0.12) 100%),
    linear-gradient(0deg, ${Colors.bgDarkBlue}, ${Colors.bgDarkBlue});
  z-index: ${Levels.mapTypeToggle};
`

const AerialText = styled(Typography)`
  display: flex;
  align-items: center;
  gap: ${Shapes.spacing[2]}px;
`
const AerialButton = styled(ButtonWithIcon)`
  width: 104px;
  margin-top: ${Shapes.spacing[2]}px;
  padding: ${Shapes.spacing[2]}px;
  border-color: ${Colors.border};
  ${useTypography(Typographies.text1)};
  color: ${Colors.textMedium};
  justify-content: flex-start;
  z-index: ${Levels.mapTypeToggle};
`

const AerialCloseButton = styled(ButtonWithIcon)`
  background-color: transparent;
  border-color: ${Colors.neutral300};
  :hover {
    background-color: rgba(255, 255, 255, 0.2);
  }
`

type AerialToggleProps = {
  disabled?: boolean
  style?: React.CSSProperties
}
export const AerialToggle = (props: AerialToggleProps) => {
  const { disabled, style } = props
  const [isAerialEnabled, setIsAerialEnabled] = useRecoilState(mainMapAtoms.isAerialEnabled)

  const onToggleAerial = () => setIsAerialEnabled(!isAerialEnabled)

  return (
    <AerialButton
      style={{
        ...style,

        borderColor: isAerialEnabled ? Colors.blueDark : Colors.border,
      }}
      disabled={disabled}
      onClick={onToggleAerial}>
      <Satellite size={16} color={Colors.blueDark} />
      Aerial {isAerialEnabled ? 'On' : 'Off'}
    </AerialButton>
  )
}

export const AerialBanner = () => {
  const setIsAerialEnabled = useSetRecoilState(mainMapAtoms.isAerialEnabled)
  const onToggleAerialOff = () => setIsAerialEnabled(false)

  return (
    <>
      <AerialBannerWrapper className={NO_PRINT_REPORTS}>
        <AerialText variant="text1m" color={Colors.textWhite}>
          <Cube size={16} color={Colors.textWhite} />
          In aerial mode, map zoom is restricted.
        </AerialText>
        <AerialCloseButton inverted onClick={onToggleAerialOff}>
          <Close size={14} />
          Exit Aerial Mode
        </AerialCloseButton>
      </AerialBannerWrapper>
    </>
  )
}
